export default [
  {
    path: '/ordemProducao/',
    name: 'ordemProducao',
    title: 'Ordem producao',
    component: () => import('../views/OrdemProducaoView.vue'),
    redirect: { name: 'ordemProducao-listar' },
    children: [
      {
        path: 'welcome',
        name: 'ordemProducao-listar',
        component: () => import('../views/OrdemProducaoWelcomeView.vue'),
        meta: {
          title: 'Ordem de Produção',
        },
      },
      {
        path: 'add',
        name: 'ordemProducao-cadastrar',
        component: () => import('../views/OrdemProducaoFormView.vue'),
        meta: {
          title: 'Cadastrar Ordem de Produção',
        },
      },
      {
        path: ':id',
        name: 'ordemProducao-editar',
        component: () => import('../views/OrdemProducaoFormView.vue'),
        meta: {
          title: 'Editar Ordem de Produção',
        },
      },
    ],
  },
];
